<template>
    <div id="app" class="app fond">
         <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages">
                    <section v-for="formalite in listeFormalitesAdmin" :key="formalite.id">
                        <div class="Fiche" v-if="formalite.categorie == 'Recensement Militaire'">
                            <div class="Infos Contact">
                                <h4>{{formalite.nom}}</h4>
                                <p class="paragraphe" v-html="formalite.description"></p>

                                <a :href="formalite.url" v-if="formalite.url != ''"><i>{{formalite.url}}</i></a>
                            </div>
                            <div class="contenu-droit-page" v-if="formalite.cerfa != ''">
                                <iframe :src="formalite.cerfa" download="allow" height="100%" width="100%"></iframe>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'ListeElectorale',
    data () {
        return{
            listeFormalitesAdmin:{
                id:0,
                nom: null,
                cerfa: null,
                url: null,
                categorie: 0,
                description: null,
                image: ''
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }
    }, 

    created(){
        axios.get(param.host+'formaliteAdmin/v1/listeFormalitesAdmin')
        .then(response =>{
        this.listeFormalitesAdmin = response.data;
            console.log('listeFormalitesAdmin', this.listeFormalitesAdmin)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            console.log(this.listePages)
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Recensement militaire'){
                    console.log(this.listePages[i])
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Recensement-Militaire.vue